export default "\n<mat-card>\n  <router-outlet></router-outlet>\n</mat-card>\n"